const calendarListViewScrollspyState = ref(undefined)

export function useCalendarListViewScrollspyState(value) {
  if (value)
    calendarListViewScrollspyState.value = value
  return { calendarListViewScrollspyState }
}
